export const categories = [
    {
        name: 'Amateur radio', id: 18
    },
    {
        name: 'Beidou Navigation System', id: 35
    },
    {
        name: 'Brightest', id: 1
    },
    {
        name: 'Celestis', id: 45
    },
    {
        name: 'CubeSats', id: 32
    },
    {
        name: 'Disaster monitoring', id: 8
    },
    {
        name: 'Earth resources', id: 6
    },
    {
        name: 'Education', id: 29
    },
    {
        name: 'Engineering', id: 28
    },
    {
        name: 'Experimental', id: 19
    },
    {
        name: 'Flock', id: 48
    },
    {
        name: 'Galileo', id: 22
    },
    {
        name: 'Geodetic', id: 27
    },
    {
        name: 'Geostationary', id: 10
    },
    {
        name: 'Global Positioning System(GPS) Constellation', id: 50
    },
    {
        name: 'Global Positioning System(GPS) Operational', id: 20
    },
    {
        name: 'Globalstar', id: 17
    },
    {
        name: 'Glonass Constellation', id: 51
    },
    {
        name: 'Glonass Operational', id: 21
    },
    {
        name: 'GOES', id: 5
    },
    {
        name: 'Gonets', id: 40
    },
    {
        name: 'Gorizont', id: 12
    },
    {
        name: 'Intelsat', id: 11
    },
    {
        name: 'Iridium', id: 15
    },
    {
        name: 'IRNSS', id: 46
    },
    {
        name: 'ISS', id: 2
    },
    {
        name: 'Lemur', id: 49
    },
    {
        name: 'Military', id: 30
    },
    {
        name: 'Molniya', id: 14
    },
    {
        name: 'Navy Navigation Satellite System', id: 24
    },
    {
        name: 'NOAA', id: 4
    },
    {
        name: 'O3B Networks', id: 43
    },
    {
        name: 'Orbcomm', id: 16
    },
    {
        name: 'Parus', id: 38
    },
    {
        name: 'QZSS', id: 47
    },
    {
        name: 'Radar Calibration', id: 31
    },
    {
        name: 'Raduga', id: 13
    },
    {
        name: 'Russian LEO Navigation', id: 25
    },
    {
        name: 'Satellite - Based Augmentation System', id: 23
    },
    {
        name: 'Search & rescue', id: 7
    },
    {
        name: 'Space & Earth Science', id: 26
    },
    {
        name: 'Starlink', id: 52
    },
    {
        name: 'Strela', id: 39
    },
    {
        name: 'Tracking and Data Relay Satellite System', id: 9
    },
    {
        name: 'Tselina', id: 44
    },
    {
        name: 'Tsikada', id: 42
    },
    {
        name: 'Tsiklon', id: 41
    },
    {
        name: 'TV', id: 34
    },
    {
        name: 'Weather', id: 3
    },
    {
        name: 'Westford Needles', id: 37
    },
    {
        name: 'XM and Sirius', id: 33
    },
    {
        name: 'Yaogan', id: 36
    }

]